<template>
  <span>{{formattedTotal}}</span>
</template>

<script>
import PaymentsCalculationsAPI from "../../api/PaymentsCalculationsAPI";
import convertDecimalForChart from '../../../../utils/converters/convert.decimal.for.chart';
export default {
  props: {
    contractId: {
      required: true
    },
    currentVersionId: {
      required: true,
      default: null
    },
  },
  data() {
    return {
      paymentLiabilities: null
    };
  },
  computed: {
    total() {
      if (!this.paymentLiabilities) return null;
      return this.paymentLiabilities.totalLiabilitiesCost;
    },
    formattedTotal() {
      if(this.total === null) return null
      return convertDecimalForChart(this.total)
    }
  },
  async created() {
    await this.calculate();
  },
  methods: {
    async calculate() {
      this.$fileLoadingManager.startLoading();
      try {
        const paymentAPI = new PaymentsCalculationsAPI();
        this.paymentLiabilities = await paymentAPI.calculateLiabilitiesResult(
          this.contractId,
          this.currentVersionId
        );
      } catch (e) {
        console.error(e);
      } finally {
        this.$fileLoadingManager.finishLoading();
      }
    }
  }
};
</script>

<style>
</style>
